export default {
  id: null,
  regulationAutoID: null,
  expertID: null,
  schedulingContactID: null,
  schedulingTypeID: null,
  dateScheduling: null,
  instructions: null,
  observations: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/auto/sinisterschedulingmodel.js